import { getRouteApi } from '@tanstack/react-router'
import { DateTime, Hr } from 'ui/components'
import { Info, InfoSet } from 'ui/components/Info'
import { Link } from 'ui/components/Link'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Col, Row } from 'ui/themes/globalStyles'
import { DocumentActions } from '~bank-documents/components/DocumentActions'
import { DocumentPeriodStatus } from '~bank-documents/components/DocumentPeriodStatus'

export const PeriodInformation = () => {
  const routeApi = getRouteApi('/_app/documents/$documentId/periods/$periodId')
  const periodId = routeApi.useParams({ select: (s) => Number(s.periodId) })
  const data = routeApi.useLoaderData()
  const {
    documentId,
    documentName,
    expirationDate,
    showDeliveredAt,
    startDate,
    endDate,
    showLicenseName,
    showLicenseId,
    updatedAt,
    status,
    notes
  } = data

  const leftColInfo: React.JSX.Element[] = [
    <Info label="Document Name">
      <Link to="/documents/$documentId" params={{ documentId: documentId.toString() }}>
        {documentName}
      </Link>
    </Info>,
    ...(showDeliveredAt ? [<Info label="Delivered at">{showDeliveredAt}</Info>] : []),
    <Info label="Start Date">{startDate}</Info>,
    <Info label="End Date">{endDate}</Info>,
    <Info label="Status">
      <DocumentPeriodStatus name={status} />
    </Info>
  ]

  const rightColInfo = [
    showLicenseName ? (
      <Info label="License Name">
        {showLicenseName && showLicenseId && (
          <Link to="/licenses/$licenseId" params={{ licenseId: showLicenseId.toString() }}>
            {showLicenseName}
          </Link>
        )}
      </Info>
    ) : null,
    <Info label="Expiration Date">{expirationDate}</Info>,
    <Info label="Last Modified Date">
      <DateTime date={updatedAt} withTime />
    </Info>
  ].filter(Boolean)

  const arrayLength = leftColInfo.length > rightColInfo.length ? leftColInfo.length : rightColInfo.length

  return (
    <PageSection
      face={PageSectionFace.SECONDARY}
      title="Period Information"
      actions={
        <DocumentActions
          editButtonParams={{ to: '/documents/$documentId/periods/$periodId/edit', params: { documentId, periodId } }}
        />
      }
    >
      <Hr />
      <InfoSet>
        {new Array(arrayLength).fill(null).map((_, index) => (
          <Row key={'row' + index}>
            <Col>{leftColInfo[index]}</Col>

            <Col>{rightColInfo[index]}</Col>
          </Row>
        ))}
        <Info label="Notes (visible for client)">{notes || null}</Info>
      </InfoSet>
      <Hr />
    </PageSection>
  )
}
